const PRESET_TAB_STYLES = [
  { key: 'tab-0', width: '100px', opacity: 1 },
  { key: 'tab-1', width: '90px', opacity: 0.5 },
  { key: 'tab-2', width: '90px', opacity: 0.5 },
  { key: 'tab-3', width: '90px', opacity: 0.5 },
  { key: 'tab-4', width: '80px', opacity: 0.5 },
];

export const TabsSkeleton = () => (
  <div className='flex gap-2 overflow-x-auto scrollbar-hide pb-0 pl-4 xs:pl-0'>
    {PRESET_TAB_STYLES.map(({ key, ...style }) => (
      <div key={key} className='h-9 bg-tertiary rounded-full shrink-0' style={style} />
    ))}
  </div>
);
